import { render, staticRenderFns } from "./VideoDialogAd.vue?vue&type=template&id=0c67da5a&scoped=true"
import script from "./VideoDialogAd.vue?vue&type=script&lang=js"
export * from "./VideoDialogAd.vue?vue&type=script&lang=js"
import style0 from "./VideoDialogAd.vue?vue&type=style&index=0&id=0c67da5a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c67da5a",
  null
  
)

export default component.exports